import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "availability-configuration-modal" };
const _hoisted_2 = { class: "relative bg-white border rounded-lg shadow-2xl dark:bg-gray-700 flex flex-col max-h-[90vh]" };
const _hoisted_3 = { class: "flex items-center justify-between p-4 rounded-t md:p-5 dark:border-gray-600" };
const _hoisted_4 = { class: "text-xl font-semibold text-gray-900 dark:text-white" };
const _hoisted_5 = { class: "sr-only" };
const _hoisted_6 = { class: "flex-1 min-h-0 px-1 overflow-y-auto" };
const _hoisted_7 = { class: "flex flex-col m-4" };
const _hoisted_8 = { class: "pb-2 text-sm" };
const _hoisted_9 = { class: "flex justify-center gap-4 px-2 py-1.5 rounded-lg bg-eblack-100 w-fit" };
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
    key: 0,
    class: "p-4 pt-0 space-y-2"
};
const _hoisted_13 = { class: "text-sm" };
const _hoisted_14 = {
    id: "date-range-picker",
    "date-rangepicker": "",
    class: "flex items-center pt-0"
};
const _hoisted_15 = { class: "relative" };
const _hoisted_16 = { class: "relative" };
const _hoisted_17 = {
    key: 1,
    class: "p-4 pt-0 space-y-2"
};
const _hoisted_18 = { class: "text-sm" };
const _hoisted_19 = { class: "px-2 py-1.5 rounded-lg bg-eblack-100" };
const _hoisted_20 = { class: "grid grid-cols-7 gap-2" };
const _hoisted_21 = ["checked", "onChange"];
const _hoisted_22 = { class: "flex items-center justify-between p-4 mr-3 space-y-2" };
const _hoisted_23 = { class: "space-y-2" };
const _hoisted_24 = { class: "text-sm" };
const _hoisted_25 = { class: "flex items-center gap-2" };
const _hoisted_26 = { class: "flex" };
const _hoisted_27 = { class: "flex items-center gap-2" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    key: 2,
    class: "grid grid-cols-2 gap-4 px-4 py-2 mb-4"
};
const _hoisted_30 = {
    class: "block mb-1 text-sm",
    for: "overcapacity_max_participants"
};
const _hoisted_31 = { class: "flex items-center gap-2" };
const _hoisted_32 = {
    class: "block mb-1 text-sm",
    for: "overflow_price"
};
const _hoisted_33 = { class: "relative flex items-center" };
const _hoisted_34 = { class: "grid grid-cols-2 gap-4 px-4 py-2 mb-4" };
const _hoisted_35 = { class: "space-y-2" };
const _hoisted_36 = { class: "text-sm" };
const _hoisted_37 = { class: "relative w-24" };
const _hoisted_38 = { class: "pt-0 space-y-2" };
const _hoisted_39 = { class: "text-sm" };
const _hoisted_40 = { class: "relative w-24" };
const _hoisted_41 = { class: "px-4 py-2 space-y-2" };
const _hoisted_42 = { class: "block mb-1 text-sm" };
const _hoisted_43 = { class: "relative flex items-center" };
const _hoisted_44 = { class: "flex border border-gray-300 rounded-lg bg-eblack-100 h-[42px] ml-2" };
const _hoisted_45 = ["data-tooltip-target", "aria-label", "aria-pressed"];
const _hoisted_46 = ["data-tooltip-target", "aria-label", "aria-pressed"];
const _hoisted_47 = ["id"];
const _hoisted_48 = ["id"];
const _hoisted_49 = { class: "px-4 py-2 space-y-2" };
const _hoisted_50 = {
    class: "block mb-1 text-sm",
    for: "commission_amount"
};
const _hoisted_51 = { class: "flex items-center gap-2" };
const _hoisted_52 = { class: "flex border border-gray-300 rounded-lg bg-eblack-100 h-[38px]" };
const _hoisted_53 = ["data-tooltip-target", "aria-label", "aria-pressed"];
const _hoisted_54 = ["data-tooltip-target", "aria-label", "aria-pressed"];
const _hoisted_55 = ["id"];
const _hoisted_56 = ["id"];
const _hoisted_57 = { class: "mx-4 my-3 border border-gray-200 rounded-lg bg-gray-50" };
const _hoisted_58 = { class: "px-4 pt-3 pb-2" };
const _hoisted_59 = { class: "mb-2 text-xs font-semibold tracking-wide text-gray-500 uppercase" };
const _hoisted_60 = { class: "space-y-1 text-sm" };
const _hoisted_61 = { class: "flex justify-between" };
const _hoisted_62 = { class: "text-gray-600" };
const _hoisted_63 = { class: "flex justify-between" };
const _hoisted_64 = { class: "text-gray-600" };
const _hoisted_65 = { class: "flex justify-between" };
const _hoisted_66 = { class: "text-gray-600" };
const _hoisted_67 = { class: "pt-1 mt-1 border-t border-gray-200" };
const _hoisted_68 = { class: "flex justify-between font-semibold" };
const _hoisted_69 = { class: "px-4 pt-2 pb-3" };
const _hoisted_70 = { class: "mb-2 text-xs font-semibold tracking-wide text-gray-500 uppercase" };
const _hoisted_71 = { class: "space-y-1 text-sm" };
const _hoisted_72 = { class: "flex justify-between" };
const _hoisted_73 = { class: "text-gray-600" };
const _hoisted_74 = { class: "flex justify-between" };
const _hoisted_75 = { class: "text-gray-600" };
const _hoisted_76 = { class: "text-red-600" };
const _hoisted_77 = { class: "flex justify-between" };
const _hoisted_78 = { class: "text-gray-600" };
const _hoisted_79 = { class: "pt-1 mt-1 border-t border-gray-200" };
const _hoisted_80 = { class: "flex justify-between font-semibold" };
const _hoisted_81 = { class: "text-green-700" };
const _hoisted_82 = { class: "p-4 space-y-2" };
const _hoisted_83 = { class: "flex items-center cursor-pointer select-none" };
const _hoisted_84 = { class: "ml-2 text-sm text-gray-900 dark:text-white" };
const _hoisted_85 = { class: "text-xs text-gray-400 dark:text-gray-400" };
const _hoisted_86 = {
    key: 0,
    class: "flex items-center justify-end p-4 bg-white border-t border-gray-200 rounded-b dark:border-gray-600 dark:bg-gray-700"
};
import { i18n } from "@/i18n";
import { watch } from "vue";
import { useToast } from "vue-toastification";
import { useAvailabilityForm } from "@/domains/scheduling/composables/useAvailabilityForm";
import { DAY_LABELS } from "@/domains/scheduling/utils/day-mapper";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AvailabilityConfigurationModal',
    props: {
        service: {},
        editingAvailability: {},
        calendarId: {},
        readOnly: { type: Boolean },
        modePolicy: {},
        allowDraftOverrides: { type: Boolean },
        registerDirtyCheck: { type: Function }
    },
    emits: ["create-calendar", "create-override", "update-calendar", "update-override", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const readOnly = props.readOnly === true;
        const emit = __emit;
        // =============================================================================
        // VIEWMODEL
        // =============================================================================
        const form = useAvailabilityForm({
            service: props.service,
            editingAvailability: props.editingAvailability,
            calendarId: props.calendarId,
            modePolicy: readOnly ? "read-only" : props.modePolicy,
            allowDraftOverrides: props.allowDraftOverrides === true,
        });
        // =============================================================================
        // UI STATE
        // =============================================================================
        const toast = useToast();
        const tooltipPrefix = `tooltip-${Date.now()}`;
        const dayLabels = [...DAY_LABELS];
        // =============================================================================
        // DIRTY CHECK REGISTRATION
        // =============================================================================
        if (props.registerDirtyCheck) {
            props.registerDirtyCheck(() => form.isDirty.value);
        }
        // =============================================================================
        // WATCH FOR EDITING AVAILABILITY CHANGES
        // =============================================================================
        watch(() => props.editingAvailability, (newAvailability) => {
            if (newAvailability) {
                form.populateFromAvailability(newAvailability);
            }
        }, { immediate: false });
        // =============================================================================
        // EVENT HANDLERS
        // =============================================================================
        function handleSave() {
            if (readOnly) {
                return;
            }
            // Validate
            if (!form.isValid.value) {
                const firstError = form.validationErrors.value[0];
                toast.error(firstError?.message || "Por favor corrija los errores del formulario");
                return;
            }
            // Build payload
            const result = form.buildPayload();
            if (!result) {
                toast.error(i18n.global.t("calendar.auto.error_al_construir_los_datos"));
                return;
            }
            // Emit appropriate event based on mode
            switch (result.mode) {
                case "create-calendar":
                    emit("create-calendar", result.payload);
                    break;
                case "create-override":
                    emit("create-override", result.payload);
                    break;
                case "update-calendar":
                    emit("update-calendar", result.payload);
                    break;
                case "update-override":
                    emit("update-override", result.payload);
                    break;
            }
            // Reset and close
            form.reset();
            emit("close");
        }
        function handleClose() {
            if (form.isDirty.value) {
                const confirmed = window.confirm(i18n.global.t("calendar.auto.esta_seguro_de_que_desea_cerrar_los_cambios_no_g"));
                if (!confirmed)
                    return;
            }
            form.reset();
            emit("close");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("calendar.auto.ajustes_de_horario")), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center w-8 h-8 text-sm text-gray-900 bg-transparent rounded-lg hover:bg-gray-200 ms-auto dark:hover:bg-gray-600 dark:hover:text-white",
                            onClick: handleClose
                        }, [
                            _cache[18] || (_cache[18] = _createElementVNode("svg", {
                                class: "w-3 h-3",
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 14 14"
                            }, [
                                _createElementVNode("path", {
                                    stroke: "currentColor",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                })
                            ], -1)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("calendar.auto.close_modal")), 1)
                        ])
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "mx-4 border-gray-200" }, null, -1)),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("fieldset", {
                            disabled: readOnly,
                            class: "contents"
                        }, [
                            _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "mx-4 border-gray-200" }, null, -1)),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("calendar.auto.aplicar_estos_ajustes_para")), 1),
                                _createElementVNode("div", _hoisted_9, [
                                    (_unref(form).canSelectAll.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: _normalizeClass([
                                                'px-3 py-1 rounded border focus:outline-none transition-colors',
                                                _unref(form).selectedOption.value === 'all'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                                _unref(form).isModeLocked.value ? 'cursor-not-allowed opacity-75' : '',
                                            ]),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(form).setSelectedOption('all'))),
                                            disabled: _unref(form).isModeLocked.value,
                                            type: "button"
                                        }, _toDisplayString(_ctx.$t("calendar.auto.todas_las_fechas")), 11, _hoisted_10))
                                        : _createCommentVNode("", true),
                                    (_unref(form).canSelectRange.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass([
                                                'px-3 py-1 rounded border focus:outline-none transition-colors',
                                                _unref(form).selectedOption.value === 'range'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                                _unref(form).isModeLocked.value
                                                    ? 'opacity-50 cursor-not-allowed'
                                                    : '',
                                            ]),
                                            onClick: _cache[1] || (_cache[1] = ($event) => (_unref(form).setSelectedOption('range'))),
                                            disabled: _unref(form).isModeLocked.value,
                                            type: "button"
                                        }, _toDisplayString(_ctx.$t("calendar.auto.rango_de_dias")), 11, _hoisted_11))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (_unref(form).selectedOption.value === 'range')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("calendar.auto.rango_de_fechas")), 1),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "datepicker-range-start",
                                                name: "start",
                                                type: "date",
                                                class: "bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-eorange-400 focus:border-eorange-400 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                placeholder: "",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).formState.dateRange.start) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(form).formState.dateRange.start]
                                            ])
                                        ]),
                                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mx-4 text-gray-500" }, "a", -1)),
                                        _createElementVNode("div", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "datepicker-range-end",
                                                name: "end",
                                                type: "date",
                                                class: "bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-eorange-400 focus:border-eorange-400 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                placeholder: "",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).formState.dateRange.end) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(form).formState.dateRange.end]
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(form).selectedOption.value === 'all')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("calendar.auto.dias_de_la_semana")), 1),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dayLabels, (day) => {
                                                return _createElementVNode("label", {
                                                    key: day,
                                                    class: "flex items-center justify-around cursor-pointer select-none"
                                                }, [
                                                    _createElementVNode("input", {
                                                        type: "checkbox",
                                                        class: "sr-only peer",
                                                        checked: _unref(form).formState.days.includes(day),
                                                        onChange: ($event) => (_unref(form).toggleDay(day))
                                                    }, null, 40, _hoisted_21),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["px-2 py-1 ml-0 text-sm text-black transition-all bg-transparent border-gray-300 rounded peer-checked:shadow peer-checked:bg-white", {
                                                                'bg-white shadow': _unref(form).formState.days.includes(day),
                                                            }])
                                                    }, _toDisplayString(day), 3)
                                                ]);
                                            }), 64))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _cache[32] || (_cache[32] = _createElementVNode("hr", { class: "mx-4" }, null, -1)),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("calendar.auto.capacidad_estandar")), 1),
                                    _createElementVNode("div", _hoisted_25, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            min: "1",
                                            class: "w-16 px-2 text-center border border-gray-300 rounded-lg focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).formState.standardMaxParticipants) = $event))
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                _unref(form).formState.standardMaxParticipants,
                                                void 0,
                                                { number: true }
                                            ]
                                        ]),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.auto.personas")), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).showOverbookingConfig.value) = $event)),
                                            disabled: !_unref(form).canEnableOverbooking.value,
                                            class: "w-5 h-5 transition-colors duration-200 bg-white border border-gray-300 rounded appearance-none checked:bg-eorange-400 checked:border-eorange-400 focus:ring-eorange-400 focus:border-eorange-400 disabled:opacity-50 disabled:cursor-not-allowed"
                                        }, null, 8, _hoisted_28), [
                                            [_vModelCheckbox, _unref(form).showOverbookingConfig.value]
                                        ]),
                                        _createElementVNode("p", {
                                            class: _normalizeClass(["text-sm", { 'text-gray-400': !_unref(form).canEnableOverbooking.value }])
                                        }, _toDisplayString(_ctx.$t("calendar.auto.permitir_sobreventa")), 3)
                                    ])
                                ])
                            ]),
                            (_unref(form).showOverbookingConfig.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("calendar.auto.capacidad_adicional")), 1),
                                        _createElementVNode("div", _hoisted_31, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                min: "1",
                                                id: "overcapacity_max_participants",
                                                class: "w-16 px-2 text-center border border-gray-300 rounded-lg focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).formState.overcapacityMaxParticipants) = $event))
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    _unref(form).formState.overcapacityMaxParticipants,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ]),
                                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.auto.personas_extra")), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("calendar.auto.precio_por_persona_extra")), 1),
                                        _createElementVNode("div", _hoisted_33, [
                                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "absolute text-gray-500 left-3" }, "$", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                min: "0",
                                                step: "0.10",
                                                id: "overflow_price",
                                                class: "w-24 py-2 text-center border border-gray-300 rounded-lg pl-7 focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).formState.overflowPrice) = $event))
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    _unref(form).formState.overflowPrice,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("calendar.auto.hora_de_inicio")), 1),
                                    _createElementVNode("div", _hoisted_37, [
                                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3" }, [
                                            _createElementVNode("svg", {
                                                class: "w-4 h-4 text-gray-500 dark:text-gray-400",
                                                "aria-hidden": "true",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20"
                                            }, [
                                                _createElementVNode("path", { d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 14.5A6.5 6.5 0 1 1 10 3.5a6.5 6.5 0 0 1 0 13Zm.75-6.25V6a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 .22.53l2.5 2.5a.75.75 0 1 0 1.06-1.06l-2.28-2.28Z" })
                                            ])
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "time",
                                            class: "p-2 text-center border border-gray-300 rounded-lg w-fit ps-10 focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(form).formState.startTime) = $event))
                                        }, null, 512), [
                                            [_vModelText, _unref(form).formState.startTime]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("calendar.auto.hora_de_finalizacion")), 1),
                                    _createElementVNode("div", _hoisted_40, [
                                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3" }, [
                                            _createElementVNode("svg", {
                                                class: "w-4 h-4 text-gray-500 dark:text-gray-400",
                                                "aria-hidden": "true",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20"
                                            }, [
                                                _createElementVNode("path", { d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 14.5A6.5 6.5 0 1 1 10 3.5a6.5 6.5 0 0 1 0 13Zm.75-6.25V6a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 .22.53l2.5 2.5a.75.75 0 1 0 1.06-1.06l-2.28-2.28Z" })
                                            ])
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "time",
                                            class: "p-2 text-center border border-gray-300 rounded-lg w-fit ps-10 focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(form).formState.endTime) = $event))
                                        }, null, 512), [
                                            [_vModelText, _unref(form).formState.endTime]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(form).formState.priceType === "PERSON"
                                    ? "Precio base por persona"
                                    : "Costo del servicio"), 1),
                                _createElementVNode("div", _hoisted_43, [
                                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "absolute text-gray-500 left-3" }, "$", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.10",
                                        class: "py-2 text-center border border-gray-300 rounded-lg min-w-20 max-w-28 w-fit pl-7 focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(form).formState.netPrice) = $event)),
                                        onBlur: _cache[11] || (_cache[11] = ($event) => (_unref(form).formState.netPrice = Number(_unref(form).formState.netPrice) || 0))
                                    }, null, 544), [
                                        [
                                            _vModelText,
                                            _unref(form).formState.netPrice,
                                            void 0,
                                            { number: true }
                                        ]
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("button", {
                                            "data-tooltip-target": `${tooltipPrefix}-person`,
                                            type: "button",
                                            "aria-label": _ctx.$t('calendar.auto.precio_por_persona'),
                                            "aria-pressed": _unref(form).formState.priceType === 'PERSON',
                                            class: _normalizeClass([
                                                'px-3 py-1 text-md focus:outline-none transition-colors rounded-l-lg',
                                                _unref(form).formState.priceType === 'PERSON'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                            ]),
                                            onClick: _cache[12] || (_cache[12] = ($event) => (_unref(form).formState.priceType = 'PERSON'))
                                        }, [...(_cache[23] || (_cache[23] = [
                                                _createElementVNode("svg", {
                                                    class: "w-6 h-6 text-gray-800 dark:text-white",
                                                    "aria-hidden": "true",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "24",
                                                    height: "24",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24"
                                                }, [
                                                    _createElementVNode("path", {
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        d: "M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                                    })
                                                ], -1)
                                            ]))], 10, _hoisted_45),
                                        _createElementVNode("button", {
                                            "data-tooltip-target": `${tooltipPrefix}-hour`,
                                            type: "button",
                                            "aria-label": _ctx.$t('calendar.auto.precio_por_hora'),
                                            "aria-pressed": _unref(form).formState.priceType === 'HOUR',
                                            class: _normalizeClass([
                                                'px-3 py-1 text-md focus:outline-none transition-colors rounded-r-lg',
                                                _unref(form).formState.priceType === 'HOUR'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                            ]),
                                            onClick: _cache[13] || (_cache[13] = ($event) => (_unref(form).formState.priceType = 'HOUR'))
                                        }, [...(_cache[24] || (_cache[24] = [
                                                _createElementVNode("svg", {
                                                    class: "w-6 h-6 text-gray-800 dark:text-white",
                                                    "aria-hidden": "true",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "24",
                                                    height: "24",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24"
                                                }, [
                                                    _createElementVNode("path", {
                                                        stroke: "currentColor",
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        "stroke-width": "2",
                                                        d: "M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                    })
                                                ], -1)
                                            ]))], 10, _hoisted_46),
                                        _createElementVNode("div", {
                                            id: `${tooltipPrefix}-person`,
                                            role: "tooltip",
                                            class: "absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 tooltip"
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("calendar.auto.por_persona")), 1),
                                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
                                        ], 8, _hoisted_47),
                                        _createElementVNode("div", {
                                            id: `${tooltipPrefix}-hour`,
                                            role: "tooltip",
                                            class: "absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 tooltip"
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("calendar.auto.por_hora")), 1),
                                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
                                        ], 8, _hoisted_48)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("calendar.auto.comision_del_concierge")), 1),
                                _createElementVNode("div", _hoisted_51, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        id: "commission_amount",
                                        class: "px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-eorange-400 focus:border-eorange-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(form).formState.commissionAmount) = $event))
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            _unref(form).formState.commissionAmount,
                                            void 0,
                                            { number: true }
                                        ]
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("button", {
                                            "data-tooltip-target": `${tooltipPrefix}-percentage`,
                                            type: "button",
                                            "aria-label": _ctx.$t('calendar.auto.comision_porcentual'),
                                            "aria-pressed": _unref(form).formState.commissionType === 'PERCENTAGE',
                                            class: _normalizeClass([
                                                'px-3 py-1 text-md focus:outline-none transition-colors rounded-l-lg',
                                                _unref(form).formState.commissionType === 'PERCENTAGE'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                            ]),
                                            onClick: _cache[15] || (_cache[15] = ($event) => (_unref(form).formState.commissionType = 'PERCENTAGE'))
                                        }, " % ", 10, _hoisted_53),
                                        _createElementVNode("button", {
                                            "data-tooltip-target": `${tooltipPrefix}-fixed`,
                                            type: "button",
                                            "aria-label": _ctx.$t('calendar.auto.comision_fija'),
                                            "aria-pressed": _unref(form).formState.commissionType === 'FIXED',
                                            class: _normalizeClass([
                                                'px-3 py-1 text-md focus:outline-none transition-colors rounded-r-lg',
                                                _unref(form).formState.commissionType === 'FIXED'
                                                    ? 'bg-white shadow'
                                                    : 'bg-transparent text-black',
                                            ]),
                                            onClick: _cache[16] || (_cache[16] = ($event) => (_unref(form).formState.commissionType = 'FIXED'))
                                        }, " # ", 10, _hoisted_54),
                                        _createElementVNode("div", {
                                            id: `${tooltipPrefix}-percentage`,
                                            role: "tooltip",
                                            class: "absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 tooltip"
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("calendar.auto.porcentual")), 1),
                                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
                                        ], 8, _hoisted_55),
                                        _createElementVNode("div", {
                                            id: `${tooltipPrefix}-fixed`,
                                            role: "tooltip",
                                            class: "absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 tooltip"
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("calendar.auto.fijo")), 1),
                                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
                                        ], 8, _hoisted_56)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t("calendar.auto.precio_al_cliente")), 1),
                                    _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("div", _hoisted_61, [
                                            _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t("calendar.auto.servicio")), 1),
                                            _createElementVNode("span", null, "$" + _toDisplayString(_unref(form).pricingBreakdown.value.netPrice.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("span", _hoisted_64, [
                                                _createTextVNode(_toDisplayString(_ctx.$t("calendar.auto.comision_del_concierge")), 1),
                                                (_unref(form).formState.commissionType === 'PERCENTAGE')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode("(" + _toDisplayString(_unref(form).formState.commissionAmount) + "%)", 1)
                                                    ], 64))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("span", null, "+ $" + _toDisplayString(_unref(form).pricingBreakdown.value.commission.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("span", _hoisted_66, "IVA (" + _toDisplayString((_unref(form).formState.taxRate * 100).toFixed(0)) + "%)", 1),
                                            _createElementVNode("span", null, "+ $" + _toDisplayString(_unref(form).pricingBreakdown.value.tax.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("div", _hoisted_68, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.auto.total")), 1),
                                                _createElementVNode("span", null, "$" + _toDisplayString(_unref(form).totalPrice.value.toFixed(2)), 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                _cache[30] || (_cache[30] = _createElementVNode("hr", { class: "border-gray-200" }, null, -1)),
                                _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t("calendar.auto.tu_ingreso")), 1),
                                    _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, [
                                            _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t("calendar.auto.precio_del_servicio")), 1),
                                            _createElementVNode("span", null, "$" + _toDisplayString(_unref(form).providerBreakdown.value.servicePrice.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("span", _hoisted_75, "Comisión de Emanta (" + _toDisplayString(_unref(form).isRuntimePricingConfigLoading.value
                                                ? "..."
                                                : _unref(form).providerBreakdown.value.emantaRate) + "%)", 1),
                                            _createElementVNode("span", _hoisted_76, "- $" + _toDisplayString(_unref(form).providerBreakdown.value.emantaCommission.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_77, [
                                            _createElementVNode("span", _hoisted_78, "IVA recaudado (" + _toDisplayString((_unref(form).providerBreakdown.value.taxRate * 100).toFixed(0)) + "%)", 1),
                                            _createElementVNode("span", null, "+ $" + _toDisplayString(_unref(form).providerBreakdown.value.vatOnService.toFixed(2)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.auto.tu_recibir_aacute_s")), 1),
                                                _createElementVNode("span", _hoisted_81, "$" + _toDisplayString(_unref(form).providerBreakdown.value.payout.toFixed(2)), 1)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("label", _hoisted_83, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(form).formState.allowReservations) = $event)),
                                        class: "w-5 h-5 transition-colors duration-200 bg-white border border-gray-300 rounded appearance-none checked:bg-eorange-400 checked:border-eorange-400 focus:ring-eorange-400 focus:border-eorange-400"
                                    }, null, 512), [
                                        [_vModelCheckbox, _unref(form).formState.allowReservations]
                                    ]),
                                    _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t("calendar.auto.permitir_reservas")), 1)
                                ]),
                                _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.$t("calendar.auto.al_activar_o_descativar_la_opcion_de_permitir_re")), 1)
                            ])
                        ])
                    ]),
                    (!readOnly)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("button", {
                                onClick: handleSave,
                                type: "button",
                                class: "px-8 py-2 text-sm font-medium text-white rounded-lg ms-3 focus:outline-none bg-eorange-400 hover:bg-eorange-500 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                            }, _toDisplayString(_ctx.$t("calendar.auto.guardar")), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
